import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { connect } from "react-redux";
import { postRoute } from "../../actions/routeAction";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import moment from "moment";
import { mapStyles } from "../utils/mapStyles";

// const mapStyles = {
//   width: "100%",
//   height: "600px",
// };

let geocoder;

class CreateRouteMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      routeDate: null,
      checkboxes: {},
      visible: false,
      refId: "",
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      places: [],
      stores: [],
      bounds: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this._onMouseOver = this._onMouseOver.bind(this);
    this.onMapClicked = this.onMapClicked.bind(this);
    this.displayMarkers = this.displayMarkers.bind(this);
    this.refsArray = [];
  }

  handleIdClick(refId) {
    this.setState(() => ({
      refId: refId,
    }));
  }

  componentDidMount() {
    // this.plotPoints();
    this.props;
    // this.addMerchants();
    this.filterDeliveries();
    const unroutedDeliveries = this.props.deliveries.filter(
      (del) => !del.route_id && !del.cancelled && !del.delivered
    );
    unroutedDeliveries.map((del) => {
      this.setState((prevState) => {
        return {
          checkboxes: {
            ...prevState.checkboxes,
            [del.id]: false,
          },
        };
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.deliveries != prevProps.deliveries) {
      this.filterDeliveries();
      const unroutedDeliveries = this.props.deliveries.filter(
        (del) => !del.route_id && !del.cancelled && !del.delivered
      );
      unroutedDeliveries.map((del) => {
        this.setState((prevState) => {
          return {
            checkboxes: {
              ...prevState.checkboxes,
              [del.id]: false,
            },
          };
        });
      });
    }
  }
  filterDeliveries() {
    this.setState({
      // stores: this.props.merchants,
      places: this.props.deliveries.filter((del) => {
        return (
          ((del.pickup && del.shipfrom_latitude) ||
            (!del.pickup && del.shipto_latitude)) &&
          !del.route_id &&
          !del.cancelled &&
          !del.delivered
        );
      }),
    });

    this.plotPoints();
  }
  // addMerchants() {
  //   this.setState({
  //     stores: this.props.merchants,
  //   });
  // }
  plotPoints() {
    let locations = this.getPoints(geocoder);
    // console.log("locations", locations);

    Promise.all(locations).then((returnVals) => {
      returnVals.forEach((latLng) => {
        const delId = this.props.deliveries.find(
          (place) => place.id == latLng[2]
        );

        // const places = this.state.places.filter(
        //   (place) => place.id != latLng[2]
        // );
        // console.log(delId);
        if (!delId.pickup) {
          delId.shipto_latitude = latLng[0];
          delId.shipto_longitude = latLng[1];
        } else {
          delId.shipfrom_latitude = latLng[0];
          delId.shipfrom_longitude = latLng[1];
        }

        this.setState({
          places: [...this.state.places, delId],
        });
      });
    });
  }
  getAddressData() {
    let addressData = [];
    const filteredDeliveries = this.props.deliveries.filter((del) => {
      return (
        // del.delivery_window == this.state.filteredSlot &&
        del.date == this.state.filteredDate &&
        ((!del.pickup && !del.shipto_latitude) ||
          (del.pickup && !del.shipfrom_latitude)) &&
        !del.route_id &&
        !del.cancelled
      );
    });
    for (let i = 0; i < filteredDeliveries.length; i++) {
      let location = filteredDeliveries[i].pickup
        ? `${filteredDeliveries[i].shipfrom_address1} + ${filteredDeliveries[i].shipfrom_city}`
        : `${filteredDeliveries[i].shipto_address1} + ${filteredDeliveries[i].shipto_city}`;
      addressData.push({
        id: filteredDeliveries[i].id,
        // merchant: filteredDeliveries[i].shipfrom_name,
        // window: filteredDeliveries[i].delivery_window,
        location: location,
      });
    }
    return addressData;
  }
  getPoints(geocoder) {
    let locationData = [];
    let addressData = this.getAddressData();
    for (let i = 0; i < addressData.length; i++) {
      // console.log("address", addressData);

      locationData.push(
        this.findLatLang(
          addressData[i].location,
          geocoder,
          addressData[i].id
          // addressData[i].merchant,
          // addressData[i].window
        )
      );
    }
    return locationData; // array of promises
  }

  findLatLang(address, geocoder, id) {
    return new Promise(function (resolve, reject) {
      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status === "OK") {
            // console.log(results);

            resolve([
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng(),
              id,
            ]);
          } else {
            reject(new Error("Couldnt't find the location " + address));
          }
        }
      );
    });
  }

  displayMarkers(stores) {
    return stores.map((place, index) => {
      const position = !place.pickup
        ? {
            lat: place.shipto_latitude,
            lng: place.shipto_longitude,
          }
        : {
            lat: place.shipfrom_latitude,
            lng: place.shipfrom_longitude,
          };
      const image =
        "https://maps.google.com/mapfiles/kml/shapes/road_shield3.png";

      return (
        <Marker
          ref={(ref) => {
            this.refsArray[place.id] = ref;
          }}
          label={place.order_id.toString()}
          key={index}
          id={place.id}
          title={place.delivery_window}
          merchant={place.name}
          order_id={place.order_number}
          delivery_window={place.delivery_window}
          icon={this.state.checkboxes[place.id] ? null : image}
          position={position}
          onClick={this.onMarkerClick}
          onMouseOver={this._onMouseOver}
        />
      );
    });
  }

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };
  _onMouseOver(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  }

  onMarkerClick(props, marker, e) {
    this.setState((prevState) => {
      return {
        checkboxes: {
          ...prevState.checkboxes,
          [marker.id]: !prevState.checkboxes[marker.id],
        },
        routeDate: this.state.filteredDate,
        bounds: false,
      };
    });
  }
  toggleVisible(value) {
    this.setState((prevState) => ({
      visible: value,
    }));
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState((prevState) => {
      return {
        checkboxes: { ...prevState.checkboxes, [name]: value },
        routeDate: this.state.filteredDate,
        bounds: false,
      };
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState(() => ({
      routeDate: null,
    }));
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    this.props.deliveries.map((del) => {
      if (this.state.checkboxes[del.id])
        formData.append("route[delivery_ids][]", del.id);
    });

    this.props.postRoute(formData, config);
  }

  render() {
    geocoder = new google.maps.Geocoder();
    let bounds = new google.maps.LatLngBounds();

    this.state.places.map((place) => {
      let position = place.pickup
        ? new google.maps.LatLng(
            place.shipfrom_latitude,
            place.shipfrom_longitude
          )
        : new google.maps.LatLng(place.shipto_latitude, place.shipto_longitude);
      bounds.extend(position);
      return bounds;
    });
    const { bookings, deliveries } = this.props;
    const unroutedDeliveries = deliveries.filter(
      (del) => !del.route_id && !del.cancelled && !del.delivered
    );
    // const bookings = bookings.filter((slot) => {
    //   const delivery = unroutedDeliveries.find(
    //     (del) => del.booking_id === slot.id
    //   );
    //   // console.log(delivery);
    //   return delivery && slot.date == this.state.filteredDate;
    // });
    return (
      <div>
        <div>
          <div
            className="row"
            style={{
              height: "90vh",
              width: "100%",
            }}
          >
            <div style={{ height: "600px" }} className=" col-md-7">
              <Map
                bounds={this.state.bounds ? bounds : null}
                google={window.google}
                onClick={this.onMapClicked}
                styles={mapStyles}
              >
                {/* {this.displayMarkers(this.state.stores)} */}
                {this.displayMarkers(this.state.places)}
                {/* {console.log(this.refsArray)} */}
                <InfoWindow
                  marker={this.state.activeMarker}
                  visible={this.state.showingInfoWindow}
                >
                  <div>
                    {this.state.selectedPlace.delivery_window ? (
                      <div>
                        <h5>
                          {this.state.selectedPlace.merchant} -{" "}
                          {this.state.selectedPlace.order_id}
                        </h5>
                        <br></br>
                        <h6>{this.state.selectedPlace.delivery_window}</h6>
                      </div>
                    ) : (
                      <h5>{this.state.selectedPlace.title}</h5>
                    )}
                  </div>
                </InfoWindow>
              </Map>
            </div>
            <div
              className="col-md-5"
              style={{
                display: "block",
                height: "600px",
                width: "100%",
                overflow: "auto",
                position: "relative",
              }}
            >
              <Form onSubmit={this.handleSubmit}>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr className="table-primary">
                      <th>Create Route</th>
                      <th>Timeslot</th>
                      <th>Order ID</th>
                      <th>Pick Ups</th>
                      <th>Drop Offs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookings.map((slot) => {
                      const deliveries = unroutedDeliveries.filter(
                        (del) => del.booking_id === slot.id
                      );
                      // console.log(deliveries);
                      return deliveries.map((delivery) => {
                        // const merchant = merchants.find(
                        //   (merch) => merch.id === delivery.merchant_id
                        // );
                        // const fsa = fsas.find(
                        //   (neibor) => neibor.id === delivery.fsa_id
                        // );
                        const dc =
                          delivery.entered_dc_at || delivery.pickup
                            ? "text-success"
                            : "text-danger";
                        const renderElement = () => {
                          if (
                            slot.timeslot_id == 10 ||
                            slot.timeslot_id == 14 ||
                            slot.timeslot_id == 18
                          )
                            return "table-info";
                          else if (
                            slot.timeslot_id == 11 ||
                            slot.timeslot_id == 15 ||
                            slot.timeslot_id == 19
                          )
                            return "table-dark";
                          else if (
                            slot.timeslot_id == 12 ||
                            slot.timeslot_id == 16 ||
                            slot.timeslot_id == 20
                          )
                            return "table-primary";
                          else if (
                            slot.timeslot_id == 13 ||
                            slot.timeslot_id == 17 ||
                            slot.timeslot_id == 21
                          )
                            return "table-light";
                          return null;
                        };
                        return (
                          <tr key={delivery.id} className={renderElement()}>
                            <td>
                              <Form.Check
                                type="checkbox"
                                name={delivery.id}
                                checked={this.state.checkboxes[delivery.id]}
                                onChange={this.handleChange}
                                label={`Add to route`}
                              />
                            </td>
                            <td>
                              <Link to={`/timeslots/${slot.id}`}>
                                {slot.delivery_window}
                              </Link>
                            </td>
                            <td>
                              <Link to={`/fulfillments/${delivery.order_id}`}>
                                <span
                                  className={dc}
                                  onMouseOver={() =>
                                    this._onMouseOver(
                                      this.refsArray[delivery.id].props,
                                      this.refsArray[delivery.id].marker
                                    )
                                  }
                                >
                                  {delivery.order_id}
                                  {delivery.pickup && "-R"}
                                </span>
                              </Link>
                              <br></br>
                            </td>
                            <td>{delivery.name}</td>
                            <td>
                              {delivery.neighborhood}
                              <br></br>
                            </td>
                          </tr>
                        );
                      });
                    })}
                  </tbody>
                </Table>
                {this.state.routeDate === this.state.filteredDate ? (
                  <Button variant="outline-primary" type="submit">
                    Create Route
                  </Button>
                ) : (
                  ""
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ postRoute }) => ({
  route: postRoute.route,
});
const mapDispatchToProps = (dispatch) => ({
  postRoute: (route) => dispatch(postRoute(route)),
});
export default GoogleApiWrapper({
  apiKey: "AIzaSyCgImsLUsK-v_7T9gytx9fmfHyYL4HDnSQ",
})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateRouteMap)));
